import React, { useState, useEffect, useRef } from 'react';
import { Form, Input, Table, ConfigProvider, Button, Space, Modal, Typography, message, Tag,Switch } from 'antd';
import { SearchOutlined, AuditOutlined } from '@ant-design/icons';
import { request } from '@/utils'

import Highlighter from 'react-highlight-words';
import './index.scss'
import zhCN from 'antd/locale/zh_CN';


const { Paragraph, Text } = Typography;
const Hqqsh = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const [formxf] = Form.useForm();
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);
  const [bangm, setbangm] = useState([]);
  const [ccpxx, setccpxx] = useState([]);// 选择的产品信息
  const [ticks, setticks] = useState([]);


  useEffect(() => {
    async function getau() {
      const res = await request.post('/hqqsh_list')
      setbangm(res.rescode)
    }
    getau()
  }, [ticks])

  const gohf = (v) => {
    setccpxx(v)
    formxf.setFieldsValue({ dbno: v.key});// 回传发送短信订单号码
    setOpen(true)

  }

  const onFxfsq = async (e) => {
    const rq = await request.post('/hqqsh', e)
    setOpen(false)
    setticks(rq.ticks)
    messageApi.open({ type: rq.return_code, content: rq.return_msg, });
  }


  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`检索内容`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            检索
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            重置
          </Button>

          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            关闭
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1677ff' : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    filterDropdownProps: {
      onOpenChange(open) {
        if (open) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: '#ffc069',
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });




  const columns = [
    {
      title: "",
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          <Tag color="green" onClick={() => gohf(record)}><AuditOutlined />审核</Tag>
        </Space>
      ),
    },
    {
      title: '批次编号',
      dataIndex: 'dbno',
      key: 'dbno',
      ...getColumnSearchProps('dbno'),
      sorter: (a, b) => a.key - b.key,
      sortDirections: ['descend', 'ascend'],
    },

    {
      title: '产品名称',
      dataIndex: 'pname',
      key: 'pname',
      ...getColumnSearchProps('pname'),
    },
  
    {
      title: '申请时间',
      key: 'stime',
      ...getColumnSearchProps('stime'),
      dataIndex: 'stime',
    },
    {
      title: '认证信息',
      key: 'rzxx',
      dataIndex: 'rzxx',
    },
   
    {
      title: '生产资料',
      key: 'scmsg',
      ...getColumnSearchProps('scmsg'),
      dataIndex: 'scmsg',
    },

  ];


  return (
    <>

      <ConfigProvider locale={zhCN} >
        {contextHolder}

        <div >
          <Form form={form} component={false}>

            <Table columns={columns} dataSource={bangm} size="small" />

          </Form>



        </div>


        <Modal
          // title="数据修复申请表"
          footer={null}
          centered
          open={open}
          onOk={() => onFxfsq()}
          onCancel={() => setOpen(false)}
          width={{
            xs: '90%',
            sm: '80%',
            md: '70%',
            lg: '60%',
            xl: '50%',
            xxl: '40%',
          }}
        >
          <Paragraph> 数据编号：{ccpxx.dbno} <Text>用户名：{ccpxx.pname}</Text> </Paragraph>

          <Form
            name="dbxfsq"
            layout="horizontal"
            onFinish={onFxfsq}
            form={formxf}  >

            <Form.Item name='dbno'
              hidden={true}
            >
              <Input />
            </Form.Item>



            <Form.Item label="处理意见" name='clyj' rules={[{ required: true, message: '请选择处理意见!' },]}>
            <Switch checkedChildren="通过" unCheckedChildren="拒绝" />
            </Form.Item>

            <Form.Item>
              <Button type="primary"
                htmlType="submit"
                block={true} >
                提          交
              </Button>
            </Form.Item>


          </Form>
        </Modal>



      </ConfigProvider>
    </>

  );
};
export default Hqqsh;